import { render } from "./PlatformGovernanceView.vue?vue&type=template&id=110a8483"
import script from "./PlatformGovernanceView.vue?vue&type=script&lang=js"
export * from "./PlatformGovernanceView.vue?vue&type=script&lang=js"

import "./PlatformGovernanceView.vue?vue&type=style&index=0&id=110a8483&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__